<template>
  <div>
    <v-snackbar
      v-for="snackbar in arraySnackbar"
      :key="snackbar.id"
      :value ="snackbar.visible"
      :color="snackbar.tipo"
      :timeout= -1
      top
      right
      :style="{ top: `${snackbar.posicion}px`}"
      @mouseover.native="debounceParado(snackbar)"
      @mouseleave.native="comprobarParado(snackbar)"
      :id="snackbar.id"
      :class="snackbar.mostrar ? '' : 'esconder'"
    >
      <span style="cursor: default;">{{ snackbar.texto }}</span> 
      
      <v-progress-linear
        color="white"
        absolute
        top
        :value="Math.floor(100 * (snackbar.currentTime / timeout))"
      />
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="eliminar(snackbar)"
        >
          Cerrar
        </v-btn>
      </template>                                                                   
    </v-snackbar>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    data() {
      return {
        timeout: 5000,
        arrayInterno: [],
        alturaTotal: 0,
        debounce: null,
        prueba: false
      };
    },
    methods: {
      ...mapActions(['setEliminarSnackbar']),
      debounceParado(snackbar) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => { //Se espera a que el raton esté mas de 50 milisegundos antes de ejecutar el interior si no lo esta no lo ejecuta
          snackbar.parado = true;
        }, 150);
      },

      comprobarParado(snackbar) {
        clearTimeout(this.debounce);
        if(snackbar.parado == true){ //cuando el raton sale del snackbar compruebo si se ha parado el prohreso 
          snackbar.parado = false; //En ese caso cancelo el parado
          this.aumentoProgress(snackbar); //Y llamamos de nuevo a la funcion de augmento de progreso
        }
      },
      aumentoProgress(snackbar) {
        if(snackbar.parado == false){
          setTimeout(() => { //la funcion se espera 100 milisegundos
            snackbar.currentTime += 100;//Incrementamos el contador del tiempo

            if (this.timeout <= snackbar.currentTime) { //si el contados llega a el tiempo maximo del snakbar
              this.eliminar(snackbar); // lo eliminamos
            } else { //si al snackbar aún le queda tiempo volvemos a llamar a la funcion
              this.aumentoProgress(snackbar);
            }
          }, 100);
        }

        var snackbarActual = document.getElementById(snackbar.id); //obtenemos el elemento snackbar
        if(snackbarActual && !snackbar.altura){ //si existe y aún no le hemos añadido la propiedad de la altura hacemos el calculo
          snackbar.altura = snackbarActual.firstChild.clientHeight + 10; //obtenemos la altura del elemento y le sumamos 10 que es la separacion que ponemos entre los snackbars
          snackbar.posicion = this.alturaTotal; // la posicion donde va el snackbar es la suma total de la altura de los snackbars que se estén mostrando
          this.alturaTotal += snackbar.altura; // sumamos la altura del snackbar actual a la altura total
          snackbar.mostrar = true;
        }
      },
      eliminar(snackbar){
        snackbar.visible = false; //marcamos el snakbar como falso
        
        let posicion = this.arrayInterno.indexOf(snackbar); //obtenemos la posicion del snackbar que se acaba de eliminar
        if(posicion !== -1){
          for (let index = posicion; index < this.arrayInterno.length; index++) { //recorremos todos los snackbars posteriores al snackbar eliminado
            this.arrayInterno[index].posicion -= snackbar.altura; // le restamos a las posiciones de estos snackbars la altura del snackbar eliminado
          }
          this.alturaTotal -= snackbar.altura; // también le restamos la altura dle snackbar eliminado a la altura total

          this.arrayInterno = this.arrayInterno.filter(s => s.id !== snackbar.id);
          this.setEliminarSnackbar();
        }
      }
    },
    computed: {
      ...mapState(['arraySnackbar'])
    },
    watch: {
      arraySnackbar() {
        if(this.arraySnackbar.length > 0){
          let snackbar = this.arraySnackbar[this.arraySnackbar.length-1];
          if (snackbar.visible == true && !this.arrayInterno.includes(snackbar)){
            this.arrayInterno.push(snackbar);
            this.aumentoProgress(snackbar);
          }
        }
      },
    }
};
</script>
<style>
  .esconder {
     visibility: hidden !important;
  }
</style>